module.exports = __webpack_public_path__ + "4aaad4aedb43903891925b1b6c57d0f6.png";